import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { LvdBriefingStep } from '../../utils/lvdLegislationBriefing'
import { V2LvdLegislationBriefingStepShell } from './V2LvdLegislationBriefingStepShell'

export function V2LvdProductDescriptionStep({
  step,
  index,
  description,
  hasProductDescription,
  canWrite,
  onEditDescription,
}: {
  step: LvdBriefingStep
  index: number
  description: string | null | undefined
  hasProductDescription: boolean
  canWrite: boolean
  onEditDescription: () => void
}) {
  const { t } = useTranslation('common')

  let descriptionText = t(
    'v2.pages.products.detail.lvdBriefing.productDescription.noDescription'
  )
  if (hasProductDescription && description != null) {
    descriptionText = description
  }

  return (
    <V2LvdLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        canWrite ? (
          <Button
            type='button'
            size='sm'
            variant='outline'
            onClick={onEditDescription}
          >
            {t('v2.pages.products.detail.lvdBriefing.productDescription.action')}
          </Button>
        ) : undefined
      }
    >
      <p className='whitespace-pre-wrap text-sm text-muted-foreground'>
        {descriptionText}
      </p>
    </V2LvdLegislationBriefingStepShell>
  )
}
